// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/modules/inventory-label-information/inventory-manual-create.less
// module id = 3493
// module chunks = 0